import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useConfig } from '../../hooks/useConfig';
import ExternalRedirect from './ExternalRedirect'; // 1. Import the new component

const ProtectedRoute = ({ children, adminRequired = false }) => {
    const { isAuthenticated, isLoading: isAuthLoading, user } = useAuth();
    const { config, isLoading: isConfigLoading } = useConfig();
    const location = useLocation();

    if (isAuthLoading || isConfigLoading) {
        return <div>Loading session...</div>;
    }

    if (!config) {
        return <div>Error: Application configuration could not be loaded.</div>;
    }

    if (!isAuthenticated) {
        const loginUrl = config.auth_redirect_url || '/login';

        // --- FIX START: Use the new component for external redirects ---
        if (loginUrl.startsWith('http')) {
            // Instead of a conditional hook, we now render our dedicated component.
            // This follows the Rules of Hooks.
            const redirectParam = `?redirect=${window.location.origin}${location.pathname}`;
            const fullRedirectUrl = `${loginUrl}${redirectParam}`;
            
            return <ExternalRedirect to={fullRedirectUrl} />;
        } else {
            // For internal redirects, we still use React Router's Navigate.
            return <Navigate to={`${loginUrl}?redirect=${location.pathname}`} replace />;
        }
        // --- FIX END ---
    }

    if (adminRequired && !user?.isSuperAdmin) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
